<template>
  <div>
    <div v-if="loading" class="text-center my-4">
      <b-spinner></b-spinner>
    </div>
    <div v-else>
      <div>
        <div class="mb-4">
            <h4 class="m-0 p-0">You have {{totalActivity}} activities in your lifetime.</h4>
            <p class="m-0 p-0 text-muted">Showing only recent 15 activities.</p>
        </div>
        <b-card class="mb-4 border-0 shadow-sm" v-for="(data, index) in activity" :key="index">
          <div class="">
            <b-badge variant="primary">{{ data.type }}</b-badge>
            <div v-if="data.type == 'Booking ended'">
              <p class="m-0 p-0 mt-2 text-weight-bold">
                {{ data.name }} ended the booking {{ data.bookingId }}
              </p>
            </div>
            <div v-else>
              <p class="m-0 p-0 mt-2 text-weight-bold">
                {{ data.description }}
              </p>
            </div>
            <p class="text-muted m-0 p-0">
              {{ data.createdAt | moment("lll") }}
              <span
                v-if="
                  data.type == 'first assigned' || data.type == 'Booking ended'
                "
                class="btn-link"
                @click="viewBooking(data.bookingId)"
              >
                , {{ data.bookingId }}
              </span>
              <span
                v-if="data.type == 'Vehicle Status Change'"
                class="btn-link"
                @click="viewVehicle()"
              >
                , {{ data.bookingId }}
              </span>
            </p>
          </div>
        </b-card>
        <b-card class="border-0 shadow-sm" v-if="!loading && activity.length == 0">
            <p>You don't have any activities</p>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP2 } from "../../../axios/http-common";
export default {
  data() {
    return {
      loading: false,
      activity: [],
      totalActivity: 0
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    viewBooking(id) {
      window.location.href =
        "https://ontrack-operations.web.app/viewBooking/" + id;
    },
    viewVehicle() {
      window.location.href = "https://ontrack-operations.web.app/vehicles/";
    },
    async loadData() {
      this.loading = true;
      try {
        const { data } = await HTTP2.get(
          "/agentActivity?id=" +
            Number(localStorage.getItem("agent_id")) +
            "&&limit=15"
        );
        this.activity = data.data;
        this.totalActivity = data.total;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
